import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { supabase } from '../supabaseClient';
import { useTranslation } from '../useTranslation';

export default function OrderModal({ isOpen, onClose, product }) {
  const [form, setForm] = useState({
    full_name: '',
    email: '',
    numero_telephone: '',
    address: '',
    quantity: 1,
  });

  const [mounted, setMounted] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const { t } = useTranslation();
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

    const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };
    const handleSubmit = async (e) => {
    e.preventDefault();

    const dataToInsert = {
      ...form,
      product_id: product?.id,
    };
    const { data, error } = await supabase
      .from('carts')
      .insert([dataToInsert]);

    if (error) {
      console.error('Erreur Supabase:', error.message);
      alert(t('orderError'));
    } else {
      console.log('Commande ajoutée:', data);
      setSuccessMessage(`✅ ${t('orderSuccess')}`);

      setForm({
        full_name: '',
        email: '',
        numero_telephone: '',
        address: '',
        quantity: 1,
      });

      setTimeout(() => {
        setSuccessMessage('');
        onClose();
      }, 2000);
    }
  };

  if (!isOpen || !mounted) return null;
  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Commander : {product?.name}</h2>
        <p className="price"> {t('priceLabel')} {product?.price} DT</p>

        <form onSubmit={handleSubmit}>
         

          {['full_name', 'email', 'numero_telephone', 'address'].map((field) => (
            <div key={field} className="form-group">
              <label htmlFor={field}>
                {/*{field.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')} */}
                {field === 'full_name' && t('fullName')}
      {field === 'email' && t('email')}
      {field === 'numero_telephone' && t('phoneNumber')}
      {field === 'address' && t('address')}
              </label>
              <input
                id={field}
                name={field}
                type={field === 'email' ? 'email' : 'text'}
                value={form[field]}
                onChange={handleChange}
                required={field !== 'numero_telephone'}
                placeholder={
        field === 'full_name' ? t('fullName') :
        field === 'email' ? t('email') :
        field === 'numero_telephone' ? t('phoneNumber') :
        t('address')
      }
              />
            </div>
          ))}

          <div className="form-group">
            <label htmlFor="quantity">  {t('quantity')}</label>
            <input
              id="quantity"
              name="quantity"
              type="number"
              min="1"
              max="10"
              value={form.quantity}
              onChange={handleChange}
              required />
          </div>

           {successMessage && (
            <div className="success-message">{successMessage}</div>
          )}
          
          <div className="form-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>
  {t('cancel')}
</button>
<button type="submit" className="submit-btn">
  {t('confirmOrder')}
</button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}
